/* eslint import/no-anonymous-default-export: [2, {"allowObject": true}] */
export default {
    apiKey: "AIzaSyA5KFYDBobBEeHKfx0krcMChc6GlHxJ0AI",
    authDomain: "caterpillar-123.firebaseapp.com",
    projectId: "caterpillar-123",
    storageBucket: "caterpillar-123.appspot.com",
    messagingSenderId: "464742475890",
    appId: "1:464742475890:web:14997fc10e53f9d01dbaeb",
    measurementId: "G-1CVGF5L5N0"
}